import { Map, Sparkles } from 'lucide-react';
import WordCarousel from './WordCarousel';

const Headline = () => {
  const scrollToWaitlist = () => {
    const waitlistElement = document.getElementById('waitlist');
    if (waitlistElement) {
      waitlistElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="container mx-auto px-4 py-8 relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div 
            onClick={scrollToWaitlist}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full px-8 py-3 mb-6 border border-blue-200 shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer transition-all duration-300"
          >
            <span className="text-blue-700 font-medium text-lg">The AI COO for Small Business</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-slate-800 mb-6 leading-tight">
            Your <WordCarousel />{' '}
            <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-800 bg-clip-text text-transparent">
              business partner
            </span>
            <br />- without the salary
          </h1>

          <p className="text-2xl text-slate-600">
            You know the craft. Carto knows the business.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Headline;
